import React from "react";
import { Route, Routes } from "react-router-dom";

import ProductFormPage from "@/components/screens/ProductFormPage";
import Products from "@/components/screens/Products";
import { PRODUCT_FORM_PAGE_MESSAGES } from "@/messages/products/product-form-page.messages";
import { PRODUCTS_MESSAGES } from "@/messages/products/product.messages";

const ProductsPage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<Products messages={PRODUCTS_MESSAGES} />} />
      <Route
        path="/create/:lang"
        element={<ProductFormPage messages={PRODUCT_FORM_PAGE_MESSAGES} />}
      />
      <Route
        path="/update/:productId/:lang"
        element={<ProductFormPage messages={PRODUCT_FORM_PAGE_MESSAGES} isEditing />}
      />
      <Route path="/" element={<Products messages={PRODUCTS_MESSAGES} />} />
    </Routes>
  );
};

export default ProductsPage;
